import React from 'react';
import Breadcrumb from '../components/Breadcrumb';
import Datenschutz from '../components/Datenschutz';

const DatenschutzPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Breadcrumb currentPage="Datenschutzerklärung" />
      <Datenschutz />
    </div>
  );
};

export default DatenschutzPage; 